import { createContext, useCallback, useContext } from 'react';

import { FormatSettings } from '@gn-audio/jss-core';

export const FormatContext = createContext<FormatSettings | undefined>(undefined);
export interface FormatContextValue {
  formatSettings?: FormatSettings;
  formatCurrency: (price?: number, decimalPlaces?: number) => string;
}
export const formatCurrencyNumber = (
  x: number,
  thousandSeparator: string,
  decimalSeparator: string,
  decimalPlaces = 2
) => {
  const parts = x.toFixed(decimalPlaces).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
  return parts.join(decimalSeparator);
};
export const useFormat = (): FormatContextValue => {
  const formatSettings = useContext(FormatContext);

  const formatCurrency = useCallback(
    (price: number, decimalPlaces = 2) => {
      if (price === undefined) {
        return '';
      }
      if (!formatSettings) {
        return '';
      }

      const {
        placeCurrencySymbolBeforePrice,
        currencySymbol,
        decimalSeparator,
        thousandSeparator,
        useCurrencySymbolSpace,
      } = formatSettings;

      const formattedNumber = formatCurrencyNumber(
        price,
        thousandSeparator,
        decimalSeparator,
        decimalPlaces
      );

      return placeCurrencySymbolBeforePrice
        ? `${currencySymbol}${useCurrencySymbolSpace ? ' ' : ''}${formattedNumber}`
        : `${formattedNumber}${useCurrencySymbolSpace ? ' ' : ''}${currencySymbol}`;
    },
    [formatSettings]
  );

  return { formatSettings, formatCurrency };
};
